import ant from './ant.js'
import cdai from './cdai.js'
import dai from './dai.js'
import ensRegistry from './ens-registry.js'
import ensResolver from './ens-resolver.js'
import erc721 from './erc721.js'
import ethStakingAccounting from './eth-staking-accounting.js'
import ethStakingPool from './eth-staking-pool.js'
import fantomSfc from './fantom-sfc.js'
import gnt from './gnt.js'
import erc20BytesParams from './ierc20-bytes-params.js'
import erc20 from './ierc20-extended.js'
import kyberv2 from './kyberv2.js'
import loomv2Swap from './loomv2-swap.js'
import matic from './matic.js'
import maticStakingManager from './matic-staking-manager.js'
import maticValidatorShare from './matic-validator-share.js'
import optimismGasOracle from './optimism-gas-oracle.js'
import repv2 from './repv2.js'
import scdMcdMigration from './scd-mcd-migration.js'

const index = {
  ant,
  cdai, // 'cdai' has been demoted. Keeping the ABI for now in case we still need it
  dai,
  erc20,
  erc20BytesParams,
  erc721,
  ethStakingAccounting,
  ethStakingPool,
  gnt, // 'golem' has been demoted. Keeping the ABI for now in case we still need it
  kyberv2,
  loomv2Swap,
  repv2,
  scdMcdMigration,
  maticValidatorShare,
  maticStakingManager,
  matic,
  fantomSfc,
  ensRegistry,
  ensResolver,
  optimismGasOracle,
}

export default index
